/** Shared panel wrapper for create single / multiple QR (fixed size) */
export const QR_CREATE_PANEL_CLASS =
  'w-full rounded-2xl border border-white/30 bg-white/10 backdrop-blur-xl shadow-lg overflow-hidden min-h-[520px] flex flex-col';

/** Dummy sites and locations for QR create flow */

export const DUMMY_QR_SITES = [
  { site_id: 'site-green-valley', site_name: 'Green Valley Society' },
  { site_id: 'site-main', site_name: 'Main campus' },
  { site_id: 'site-tower-a', site_name: 'Tower A' },
  { site_id: 'site-tower-b', site_name: 'Tower B' },
];

export const QR_AREA_TYPES = [
  { id: 'blocks', label: 'Blocks' },
  { id: 'amenities', label: 'Amenities' },
  { id: 'streets', label: 'Streets' },
];

const DEFAULT_FLOORS = [
  { id: 'ground', name: 'Ground Floor' },
  { id: 'floor-1', name: 'Floor 1' },
  { id: 'floor-2', name: 'Floor 2' },
  { id: 'floor-3', name: 'Floor 3' },
  { id: 'floor-4', name: 'Floor 4' },
];

const DEFAULT_STREETS = [
  { id: 'street-a', name: 'Street A' },
  { id: 'street-b', name: 'Street B' },
  { id: 'street-c', name: 'Street C' },
  { id: 'street-d', name: 'Street D' },
  { id: 'street-e', name: 'Street E' },
];

/** Per-site blocks, amenities, and streets for bulk QR creation */
export const DUMMY_SITE_AREAS = {
  'site-green-valley': {
    blocks: [
      { id: 'block-a', name: 'Block A', floors: DEFAULT_FLOORS },
      { id: 'block-b', name: 'Block B', floors: DEFAULT_FLOORS },
      { id: 'block-c', name: 'Block C', floors: DEFAULT_FLOORS },
    ],
    amenities: [
      { id: 'amenity-electrical', name: 'Electrical Room' },
      { id: 'amenity-sports', name: 'Sports Facilities' },
      { id: 'amenity-roads', name: 'Roads and Streets' },
      { id: 'amenity-garden', name: 'Garden' },
      { id: 'amenity-gym', name: 'Gym' },
    ],
    streets: [
      { id: 'street-a', name: 'Street A' },
      { id: 'street-b', name: 'Street B' },
      { id: 'street-c', name: 'Street C' },
      { id: 'street-d', name: 'Street D' },
      { id: 'street-e', name: 'Street E' },
    ],
  },
  'site-main': {
    blocks: [
      { id: 'block-a', name: 'Block A', floors: DEFAULT_FLOORS },
      { id: 'block-b', name: 'Block B', floors: DEFAULT_FLOORS.slice(0, 3) },
    ],
    amenities: [
      { id: 'amenity-cafeteria', name: 'Cafeteria' },
      { id: 'amenity-auditorium', name: 'Auditorium' },
    ],
    streets: [
      { id: 'street-campus', name: 'Campus Road' },
      { id: 'street-service', name: 'Service Road' },
    ],
  },
  'site-tower-a': {
    blocks: [
      { id: 'block-a', name: 'Tower A North', floors: DEFAULT_FLOORS },
      { id: 'block-b', name: 'Tower A South', floors: DEFAULT_FLOORS },
    ],
    amenities: [{ id: 'amenity-lobby', name: 'Lobby Lounge' }],
    streets: [{ id: 'street-entrance', name: 'Tower Entrance' }],
  },
  'site-tower-b': {
    blocks: [{ id: 'block-a', name: 'Tower B', floors: DEFAULT_FLOORS }],
    amenities: [{ id: 'amenity-terrace', name: 'Rooftop Terrace' }],
    streets: [{ id: 'street-rear', name: 'Rear Access' }],
  },
};

export const getSiteAreas = siteId =>
  DUMMY_SITE_AREAS[siteId] || {
    blocks: [],
    amenities: [],
    streets: DEFAULT_STREETS,
  };

export const DUMMY_LOCATION_SUGGESTIONS = [
  {
    id: 'loc-main-gate',
    label: 'Main gate',
    address: 'Main gate, Main campus',
    site_id: 'site-main',
    lat: 12.9716,
    lng: 77.5946,
  },
  {
    id: 'loc-reception',
    label: 'Reception lobby',
    address: 'Ground floor reception, Tower A',
    site_id: 'site-tower-a',
    lat: 12.9721,
    lng: 77.5952,
  },
  {
    id: 'loc-parking',
    label: 'Basement parking B2',
    address: 'Parking level B2, Main campus',
    site_id: 'site-main',
    lat: 12.9708,
    lng: 77.5938,
  },
  {
    id: 'loc-pool',
    label: 'Pool area',
    address: 'Amenity deck pool, Amenity deck',
    site_id: 'site-amenity',
    lat: 12.973,
    lng: 77.596,
  },
  {
    id: 'loc-staff',
    label: 'Staff entrance',
    address: 'Service corridor, Tower B',
    site_id: 'site-tower-b',
    lat: 12.9712,
    lng: 77.594,
  },
];

export const filterLocationSuggestions = (query, siteId) => {
  const q = (query || '').trim().toLowerCase();
  let list = DUMMY_LOCATION_SUGGESTIONS;
  if (siteId) {
    list = list.filter(loc => loc.site_id === siteId);
  }
  if (!q) return list;
  return list.filter(
    loc =>
      loc.label.toLowerCase().includes(q) ||
      loc.address.toLowerCase().includes(q)
  );
};

export const getSiteLabel = siteId => {
  const site = DUMMY_QR_SITES.find(s => s.site_id === siteId);
  return site?.site_name || '';
};
